import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Objects } from '../../../util/objects';
import { Values } from '../../../util/values';

/**
 * Bootstrap badge를 활용한 Column Compnonent
 * params.status 필수이며, 없는경우 기본 Badge로 표시
 * 참조: https://getbootstrap.com/docs/4.3/components/badge/
 */
@Component({
  selector: 'ngx-badge-column',
  template: `<ngx-tag value="{{params.value}}" status="{{status}}" [class.pointer]="useClick" (click)="onClick()"></ngx-tag>`,
  encapsulation: ViewEncapsulation.None,
})
export class BadgeColumnComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public status: string = 'basic';
  public useClick: boolean = false;

  constructor(private router: Router) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const paramsStatus = this.params.hasOwnProperty('statusPath') ? Objects.safeGetValue(this.params.data, this.params['statusPath'], 'basic') : 'basic';
    
    if (this.params.hasOwnProperty('statusRules')) {
      this.status = Values.getLabel(paramsStatus, this.params['statusRules'], 'value', 'status') ;
    } else {
      this.status = this.status;
    }

    const useClickRules: string[] = Objects.safeGetValue(this.params, 'useClickRules', null);
    
    if (useClickRules) {
      this.useClick = useClickRules.some(c => c == this.status);
    } else {
      this.useClick = Objects.safeGetValue(this.params, 'useClick', false);
    }
  }

  ngOnInit() {}

  onClick() {
    if (!this.useClick) return;

    this.params.context.clickBadge(this.params.data);
  }
}
